/**
 * Created by akrio on 2018/3/23.
 */
import {
  USER_TOKEN,
  MENU_OPEN,
  LANGUAGE,
  TIMEZONE,
  ACCOUNT_BACK,
  FIRST_DRAG,
} from "../mutation-types";
import { currentName } from "../../const/timezone";

export default {
  state: {
    token: null, // 登录所需令牌
    language: null, // 语言
    menuOpen: 1, // 菜单是否打开 0 默认 宽打开窄关闭 1窄屏打开 2 宽屏关闭
    timezone: "",
    firstDrag: true, // 是否第一次使用drag
    back: null, // 进入account前一个页面信息
  },
  mutations: {
    [FIRST_DRAG](state, firstDrag) {
      state.firstDrag = firstDrag;
    },
    [ACCOUNT_BACK](state, back) {
      state.back = back;
    },
    [TIMEZONE](state, timezone) {
      state.timezone = timezone;
    },
    [USER_TOKEN](state, token) {
      state.token = token;
    },
    [MENU_OPEN](state, open) {
      state.menuOpen = open;
    },
    [LANGUAGE](state, language) {
      state.language = language;
    },
  },
  getters: {
    [FIRST_DRAG](state) {
      return state.firstDrag;
    },
    [ACCOUNT_BACK](state) {
      // 如果返回逻辑不存在默认返回 SchedulePage 页面
      if (state.back && state.back.name) {
        return state.back;
      } else {
        return { name: "SchedulePage", query: {} };
      }
    },
    [USER_TOKEN](state) {
      return state.token;
    },
    [MENU_OPEN](state) {
      return state.menuOpen;
    },
    [TIMEZONE](state) {
      return state.timezone || currentName;
    },
    [LANGUAGE]() {
      return "en";
      // try {
      //   // 获取当前设备语言
      //   let currentLanguage = state.language || navigator.language
      //   if (state.language === '{accept_language}') {
      //     currentLanguage = navigator.language
      //   }
      //   // 获取当前所有支持的国际化语言
      //   const languages = Vue.i18n.locales()
      //   // 查看当前设置语言是否可以支持
      //   let language = languages.find(k => k === currentLanguage)
      //   console.log('完全匹配查找', language)
      //   // 如果没有找到匹配项则尝试值拼配地区即前2个单词
      //   if (!language) {
      //     console.log('完全匹配查找失败当前语言为', currentLanguage)
      //     language = languages.find(k => k.substr(0, 2).toLowerCase() === currentLanguage.substr(0, 2).toLowerCase())
      //   }
      //   console.log('計算language', language)
      //   if (language) {
      //     return language
      //   } else {
      //     return 'en'
      //   }
      // } catch (e) {
      //   return 'en'
      // }
    },
  },
};
